import { render, staticRenderFns } from "./SellerManageIndex.vue?vue&type=template&id=0814f7bc&scoped=true&"
import script from "./SellerManageIndex.vue?vue&type=script&lang=js&"
export * from "./SellerManageIndex.vue?vue&type=script&lang=js&"
import style0 from "./SellerManageIndex.vue?vue&type=style&index=0&id=0814f7bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0814f7bc",
  null
  
)

export default component.exports